<!--<template>-->
<!--    <div>-->
<!--        <h1>联系我们</h1>-->
<!--        <hr>-->

<!--        <el-form :model="form" ref="form" label-width="100px" class="demo-dynamic">-->
<!--                        <el-form-item label="">-->
<!--                            <el-radio-group v-model="radio1" >-->
<!--                                <el-radio-button label="中文简体"></el-radio-button>-->
<!--                                <el-radio-button label="中文繁体"></el-radio-button>-->
<!--                                <el-radio-button label="英文"></el-radio-button>-->
<!--                                <el-radio-button label="德文"></el-radio-button>-->
<!--                            </el-radio-group>-->

<!--                        </el-form-item>-->
<!--            <el-form-item-->
<!--                    v-for="(domain, index) in form.domains"-->
<!--                    :key="domain.key"-->
<!--                    :prop="'domains.' + index + '.value'"-->
<!--                    style="margin-bottom: 2px !important;"-->

<!--            >-->
<!--             <el-input v-model="domain.navName"></el-input>-->


<!--            </el-form-item>-->
<!--            <el-form-item>-->
<!--                <el-button type="primary" @click="submitForm('form')">提交</el-button>-->
<!--&lt;!&ndash;                <el-button @click="addDomain">新增域名</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;                <el-button @click="resetForm('form')">重置</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
<!--        </el-form>-->

<!--    </div>-->
<!--</template>-->



<!--<script>-->
<!--    import request from "@/utils/request";-->


<!--    export default {-->

<!--        data() {-->
<!--            return {-->
<!--                radio1:"中文简体",-->
<!--                textarea:"",-->
<!--                form: {-->
<!--                    domains: [],-->
<!--                    ch:[],-->
<!--                    cht:[],-->
<!--                    en:[],-->
<!--                    de:[],-->

<!--                },-->
<!--                -->
<!--            };-->
<!--        },-->
<!--        methods: {-->
<!--            submitForm(formName) {-->
<!--                if (this.radio1=="中文简体"){-->
<!--                    this.form.ch=this.form.domains-->
<!--                }else if(this.radio1=="中文繁体"){-->
<!--                    this.form.cht=this.form.domains-->
<!--                }else if(this.radio1=="英文"){-->
<!--                    this.form.en=this.form.domains-->
<!--                }else {-->
<!--                    this.form.de=this.form.domains-->

<!--                }-->

<!--                this.$refs['form'].validate((valid) => {-->
<!--                    if (valid) {-->
<!--                        request.put("/contact_Management",this.form).then(res => {-->
<!--                            if (res.code==200){-->
<!--                                this.$message({-->
<!--                                    type: 'success',-->
<!--                                    message: res.data-->
<!--                                });-->
<!--                            }else {-->
<!--                                this.$message({-->
<!--                                    type: 'warning',-->
<!--                                    message: res.data-->
<!--                                });-->
<!--                            }-->
<!--                        })-->

<!--                    } else {-->
<!--                        console.log('error submit!!');-->
<!--                        return false;-->
<!--                    }-->
<!--                });-->
<!--            },-->
<!--            resetForm(formName) {-->
<!--                this.$refs[formName].resetFields();-->
<!--            },-->
<!--            removeDomain(item) {-->
<!--                var index = this.form.domains.indexOf(item)-->
<!--                if (this.radio1=="中文简体"){-->
<!--                    if (this.form.ch[index].id!=0){-->
<!--                        this.move(this.form.ch[index].id)-->
<!--                    }-->
<!--                }else if (this.radio1=="中文繁体"){-->
<!--                    if (this.form.cht[index].id!=0){-->
<!--                        this.move(this.form.cht[index].id)-->
<!--                    }-->
<!--                }else if(this.radio1=="英文"){-->
<!--                    if (this.form.en[index].id!=0){-->
<!--                        this.move(this.form.en[index].id)-->
<!--                    }-->
<!--                }else {-->
<!--                    if (this.form.de[index].id!=0){-->
<!--                        this.move(this.form.de[index].id)-->
<!--                    }-->
<!--                }-->
<!--                if (index !== -1) {-->
<!--                    this.form.domains.splice(index, 1)-->
<!--                }-->
<!--            },-->
<!--            addDomain() {-->
<!--                this.form.domains.push({-->

<!--                    navName: '',-->
<!--                    id:0,-->
<!--                    module:"contact",-->
<!--                    parentId:0,-->
<!--                    type:'nj',-->
<!--                    sort:50,-->

<!--                });-->
<!--            },-->
<!--            move(id){-->
<!--                request.delete("/about_magangent/"+id).then(res => {-->
<!--                    if (res.code==200){-->

<!--                        this.$message({-->
<!--                            type: 'success',-->
<!--                            message: res.data-->
<!--                        });-->




<!--                    }else {-->

<!--                    }-->


<!--                })-->
<!--            }-->
<!--        },-->
<!--        mounted() {-->
<!--            let that=this;-->
<!--            request.get("/contact_Management").then(res => {-->
<!--                    this.form.ch=res.data.ch;-->
<!--                    this.form.domains=res.data.ch;-->
<!--                    this.form.cht=res.data.cht;-->
<!--                    this.form.en=res.data.en;-->
<!--                    this.form.de=res.data.de;-->








<!--            })-->


<!--        },-->
<!--        watch:{-->

<!--                radio1(news,old){-->
<!--                    if (old != news){-->

<!--                        if (old=="中文简体"){-->
<!--                            this.form.ch=this.form.domains-->
<!--                        }else if(old=="中文繁体"){-->
<!--                            this.form.cht=this.form.domains-->
<!--                        }else if(old=="英文"){-->
<!--                            this.form.en=this.form.domains-->
<!--                        }else {-->
<!--                            this.form.de=this.form.domains-->

<!--                        }-->
<!--                        if (news=="中文简体"){-->
<!--                            this.form.domains=this.form.ch-->
<!--                        }else if(news=="中文繁体"){-->
<!--                            this.form.domains=this.form.cht-->
<!--                        }else if(news=="英文"){-->
<!--                            this.form.domains=this.form.en-->
<!--                        }else {-->
<!--                            this.form.domains=this.form.de-->

<!--                        }-->
<!--                    }-->
<!--                }-->

<!--            },-->
<!--    }-->


<!--</script>-->

<!--<style scoped>-->
<!--    >>>.el-input{-->
<!--        width: 70%;-->
<!--        border: none !important;-->
<!--    }-->

<!--</style>-->






<template>
    <h1>联系我们</h1>
    <hr>
    <el-form ref="form" :model="form" >
        <el-form-item label="隐私条款">
            <div>
                <el-radio-group v-model="radio1" >
                    <el-radio-button label="中文简体"></el-radio-button>
                    <el-radio-button label="中文繁体"></el-radio-button>
                    <el-radio-button label="英文"></el-radio-button>
                    <el-radio-button label="德文"></el-radio-button>
                </el-radio-group>
            </div>
            <div style="border: 1px solid #ccc">
                <Toolbar
                        style="border-bottom: 1px solid #ccc"
                        :editor="editorRef"
                        :defaultConfig="toolbarConfig"
                        :mode="mode"
                />
                <Editor
                        style="height: 500px; overflow-y: hidden;"
                        v-model="valueHtml"
                        :defaultConfig="editorConfig"
                        :mode="mode"
                        @onCreated="handleCreated"
                />

            </div>

        </el-form-item>



        <el-form-item>
            <el-button type="primary" @click="onSubmit">立即创建</el-button>

        </el-form-item>
    </el-form>
</template>

<script>
    import '@wangeditor/editor/dist/css/style.css' // 引入 css

    import { onBeforeUnmount, ref, shallowRef, onMounted } from 'vue'
    import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
    import request from "@/utils/request";


    export default {
        components: { Editor, Toolbar },

        data(){
            return{
                radio1: '中文简体',
                form: {
                    ch:{},cht:{},en:{},de:{}
                },
                editorRef:null,
                valueHtml:"<p>模拟 Ajax 异步设置内容</p>",
                mode: 'default', // 或 'simple'
                toolbarConfig:null,
                editorConfig:null,
                handleCreated:null,


                //    图片
                fileList: []
            }
        },
        methods:{
            onSubmit() {

                if (this.radio1=="中文简体"){
                    this.form.ch.navName=this.valueHtml
                }else if(this.radio1=="中文繁体"){
                    this.form.cht.navName=this.valueHtml
                }else if(this.radio1=="英文"){
                    this.form.en.navName=this.valueHtml
                }else {
                    this.form.de.navName=this.valueHtml

                }


                // console.log(this.form.ch.navName);

                this.$refs['form'].validate((valid) => {
                    if (valid){

                        request.put("/contact_Management",this.form).then(res => {

                            if (res.code==200){
                                this.$message({
                                    type: 'success',
                                    message: res.data
                                });
                            }else {
                                this.$message({
                                    type: 'warning',
                                    message: res.data
                                });
                            }


                        })
                    }else{
                    }

                })

            },


        },
        beforeMount() {

            this.editorRef=shallowRef()
            this.valueHtml = ref('')
            this.toolbarConfig = {}
            this.editorConfig = { placeholder: '请输入内容...',
                MENU_CONF: {
                    // 图片上传
                    uploadImage: {
                        server: '/api/BackStage/productCategory/upload',
                        fieldName: 'file',
                        // 单个文件的最大体积限制，默认为 2M
                        maxFileSize: 10 * 1024 * 1024, // 10M
                        // 最多可上传几个文件，默认为 100
                        maxNumberOfFiles: 10,
                        // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
                        allowedFileTypes: ['image/*'],
                        // 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
                        meta: {
                            // token: 'xxx',
                            // otherKey: 'yyy'
                            // file:''
                        },
                        // 将 meta 拼接到 url 参数中，默认 false
                        metaWithUrl: false,

                        // 自定义增加 http  header
                        headers: {

                            'Access-Control-Allow-Origin': 'origin'
                            // Accept: 'text/x-json',
                            // otherKey: 'xxx'
                        },

                        // 跨域是否传递 cookie ，默认为 false
                        withCredentials: true,

                        // 超时时间，默认为 10 秒
                        timeout: 10 * 1000, //10 秒

                        // 上传前
                        onBeforeUpload(files) {
                            // Message({
                            //     message: '图片正在上传中,请耐心等待',
                            //     duration: 0,
                            //     customClass: 'uploadTip',
                            //     iconClass: 'el-icon-loading',
                            //     showClose: true
                            // });
                            return files;
                        },
                        // 自定义插入图片
                        customInsert(res, insertFn) {
                            // 因为自定义插入导致onSuccess与onFailed回调函数不起作用,自己手动处理
                            // 先关闭等待的Message
                            // Message.closeAll();
                            if (res.code === 200) {
                                // Message.success({
                                //     message: `${res.data.originalName} 上传成功`
                                // });
                            } else {
                                // Message.error({
                                //     message: `${res.data.originalName} 上传失败，请重新尝试`
                                // });
                            }

                            insertFn(res.data.link, res.data.name, res.data.link);
                        },

                        // 单个文件上传成功之后
                        onSuccess(file, res) {
                            // console.log(`${file.name} 上传成功`, res);

                        },

                        // 单个文件上传失败
                        onFailed(file, res) {
                            console.log(`${file.name} 上传失败`, res);
                        },

                        // 上传进度的回调函数
                        onProgress(progress) {
                            console.log('progress', progress);
                            // progress 是 0-100 的数字
                        },

                        // 上传错误，或者触发 timeout 超时
                        onError(file, err, res) {
                            console.log(`${file.name} 上传出错`, err, res);
                        }
                    },

                }}
            this.handleCreated = (editor) => {
                this.editorRef = editor // 记录 editor 实例，重要！
            }
        },
        mounted(){


            request.get("/contact_Management").then(res => {
                for (let i = 0; i <res.data.length ; i++) {
                    if (res.data[i].language=="zh"){
                        this.form.ch=res.data[i]
                        this.valueHtml=res.data[i].navName
                        // console.log(this.valueHtml);
                    }else if(res.data[i].language=="cht"){
                        this.form.cht=res.data[i]
                    }else if(res.data[i].language=="en"){
                        this.form.en=res.data[i]
                    }else{
                        this.form.de=res.data[i]
                    }
                }


            })








        },
        beforeUnmount() {

            const editor = this.editorRef
            if (editor == null) return
            editor.destroy()

        },
        watch:{

            radio1(news,old){
                let htmls=this.valueHtml

                if (old != news){


                    if (old=="中文简体"){
                        this.form.ch.navName=htmls
                    }else if(old=="中文繁体"){
                        this.form.cht.navName=htmls
                    }else if(old=="英文"){
                        this.form.en.navName=htmls
                    }else {
                        this.form.de.navName=htmls

                    }

                    if (news=="中文简体"){
                        this.valueHtml= this.form.ch.navName
                    }else if(news=="中文繁体"){
                        this.valueHtml=this.form.cht.navName
                    }else if(news=="英文"){
                        this.valueHtml=this.form.en.navName
                    }else {
                        this.valueHtml=this.form.de.navName

                    }

                }

            }
        }

    }
</script>
<style scoped lang="less">
    .gongneng{
        padding: 20px 0;
        border-bottom: 1px solid #cccccc;
        overflow: hidden;
        li:first-child{
            float: left;
            margin-left: 10px;
        }
        li:last-child{
            float: right;
            margin-right: 10px;
        }
    }
    .el-form{
        padding-top: 10px;
        .el-input{width: 40vw}
    }
    .avatar-uploader-icon {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        font-size: 28px;
        color: #8c939d;
        width: 250px;
        height: 150px;
        line-height: 150px;
        text-align: center;
    }
    .avatar-uploader-icon:hover {
        border-color: #409eff;
    }
    .avatar {
        width: 250px;
        height: 150px;
        display: block;
    }

</style>